import * as React from 'react';

import useFluxibleAction from 'js/lib/fluxibleHooks/useFluxibleAction';
import useFluxibleStore from 'js/lib/fluxibleHooks/useFluxibleStore';

import loadCourseSchedule from 'bundles/course-v2/utils/loadCourseSchedule';
import CourseScheduleStore from 'bundles/in-course-stores/stores/CourseScheduleStore';

type Props = {
  courseId: string;
};
const useCourseSchedule = ({ courseId }: Props) => {
  const executeAction = useFluxibleAction();
  const { schedule, loading, error, loaded } = useFluxibleStore(CourseScheduleStore, (store) => {
    return {
      schedule: store.schedule,
      loading: store.loading,
      error: store.error,
      loaded: store.loaded,
    };
  });

  React.useEffect(() => {
    executeAction((context) => loadCourseSchedule(context, courseId));
    // Only run on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    schedule,
    loading,
    error,
    loaded,
  };
};

export default useCourseSchedule;
